import {connect} from 'react-redux';
import axios from 'axios';
import {Platform} from "react-native";
import ExpertRegistrationMahaleMaScreen from "../ExpertRegistrationMahaleMaScreen";
import store from "../../../../../../redux/store";
import {typeExport} from "../../../../../../redux/store/type";
import * as NavigationService from "../../../../../../redux/NavigationService";
import HMAlert from "../../../../../../customviews/HMAlert";
import i18n from "../../../../../../I18n/i18n";


const mapStateToProps = (state) => ({
    results: state.reducerExpertRegistrationMahaleMaScreen.results,
    isLoading: state.reducerExpertRegistrationMahaleMaScreen.isLoading,
    NoInternetDialog: state.reducerExpertRegistrationMahaleMaScreen.NoInternetDialog,

    resultsSet: state.reducerExpertRegistrationMahaleMaScreen.resultsSet,
    isLoadingSet: state.reducerExpertRegistrationMahaleMaScreen.isLoadingSet,
    NoInternetDialogSet: state.reducerExpertRegistrationMahaleMaScreen.NoInternetDialogSet,

    position: state.reducerExpertRegistrationMahaleMaScreen.position,
    id_category: state.reducerExpertRegistrationMahaleMaScreen.id_category,


    positionPersonnel: state.reducerExpertRegistrationMahaleMaScreen.positionPersonnel,
    id_Personnel: state.reducerExpertRegistrationMahaleMaScreen.id_Personnel,

    CartList: state.reducerSplashGetAllData.CartList,
    PriceAll: state.reducerSplashGetAllData.PriceAll,

    user: state.reducerSplashGetAllData.user,
    wallet: state.reducerSplashGetAllData.wallet,
    DataSplashScreen: state.reducerSplashGetAllData,
    // token: state.reducerSplash.token,

    FoodItem: state.reducerSplashGetAllData.FoodItem,
});

const mapDispatchToProps = (dispatch) => ({
    callService: (url, params, type, typeConnection, token, func) => dispatch(callWebservice(url, params, type, typeConnection, token, func)),
    callserviceActionRefresh: (user) => dispatch(serviceActionRefresh(user)),

});

const getDataDisatch = (dispatch, url, params, type, typeConnection, token, func) => {

    switch (type) {
        case typeExport.TypeGetExpertRegistrationMahaleMaScreen:
            dispatch(serviceActionPending());

            break;

        case typeExport.TypeSetExpertRegistrationMahaleMaScreen:
            dispatch(serviceActionPendingSet());

            break;

        default:
    }
    const config = {
        headers: {
            "Content-Type": "multipart/form-data; charset=utf-8;",
            timeout: typeExport._TIMEOUT,
        }
    };
    let formData = new FormData();
    formData.append('_operation', params._operation);
    formData.append('lang', params.lang);
    formData.append('mode', params.mode);
    formData.append('token_mahale', store.getState().reducerSplashGetAllData.tokenMahaleh);
    formData.append('_session', store.getState().reducerSplashGetAllData.token == null ? '' : store.getState().reducerSplashGetAllData.token);
    formData.append('comment', params.comment);
    formData.append('record', params.record);
    formData.append('operator', params.operator);
    formData.append('needToMeeting', params.needToMeeting);
    formData.append('resultToMeeting', params.resultToMeeting);
    formData.append('platform', Platform.OS);


    let DateTime = new Date().getTime();

    let nameImage = DateTime + '.jpg';
    let nameVideo = DateTime + '.mp4';
    let nameAudio = DateTime + '.aac';
    if (params.audio && params.audio !== null) {
        formData.append('durationVoice', params.durationVoice);

        if (Platform.OS === "web") {
            //  formData.append('audio', params.audio, nameAudio + ".aac");
            formData.append('audio', params.audioBlob, nameAudio);
            //const blobFile = new File([params.audio], nameAudio + ".aac");
            //formData.append("audio", params.audioBlob);
        }
        else
            formData.append('audio', {
                uri: params.audio,
                name: nameAudio,
                type: 'audio/aac'
            });
    }

    // if (params.image && params.image !== null)
    //     if (Platform.OS === "web") {
    //         formData.append('image', params.image, nameImage );
    //
    //     }
    //     else
    //         formData.append('image', {
    //             uri: params.image,
    //             name: nameImage,
    //             type: 'image/jpeg'
    //         });
    if (params.video && params.video !== null) {
        if (Platform.OS === "web") {
            //  formData.append('audio', params.audio, nameAudio + ".aac");
            formData.append('video', params.video, nameVideo);
            //const blobFile = new File([params.audio], nameAudio + ".aac");
            //formData.append("audio", params.audioBlob);
        }
        else
            formData.append('video', {
                uri: params.video,
                name: nameVideo,
                type: 'video/mp4'
            });
    }
    /*    if (params.video && params.video !== null) formData.append('video', {
            uri: params.video,
            name: nameVideo,
            type: 'video/mp4'
        });*/
    if (params.arrImage)
        for (let i = 0; i < params.arrImage.length; i++) {


            if (Platform.OS === "web") {
                formData.append('image' + "_" + i, params.arrImage[i], `${i}_${nameImage}`);
            }
            else

                formData.append('image' + "_" + i, {
                    uri: params.arrImage[i],
                    name: nameImage,
                    type: 'image/jpeg'
                });
        }

    // var config = {
    //     headers: {'Content-Type': 'application/x-www-form-urlencoded'},
    //     responseType: 'blob'
    // };
    // axios(
    //     {
    //         url: baseUrl + url + params,
    //         method: typeConnection,
    //         headers: {
    //             'Content-Type': 'application/x-www-form-urlencoded'
    //         },
    //         timeout: typeExport._TIMEOUT,
    //         /*      headers: {'X-Requested-With': 'XMLHttpRequest'},*/
    //     }
    // )
    axios.post(url, formData, config)
        .then(response => {
            let data = response.data;
            switch (type) {
                case typeExport.TypeGetExpertRegistrationMahaleMaScreen:
                    if (response.data.status === true) {
                        // dispatch(serviceActionSuccess(data, token, response.data.user));
                        dispatch(serviceActionSuccess(data, token, ""));

                        //   NavigationService.navigatereset('MainStack');
                    }
                    else {
                        //   NavigationService.navigatereset('LoginStack');
                    }
                    break;

                case typeExport.TypeSetExpertRegistrationMahaleMaScreen:
                    if (response.data.success === true) {
                        global._refreshListOpertor = true;
                        // dispatch(serviceActionSuccess(data, token, response.data.user));
                        dispatch(serviceActionSuccessSet(data));
                        func ? func(response.data) : null;
                        NavigationService.Pop();

                        //   NavigationService.navigatereset('MainStack');
                    }
                    else {
                        dispatch(serviceActionErrorSet(e));
                        HMAlert(
                            i18n.t('constant.message'),
                            response.data?.error?.message ? response.data.error.message : "مجددا تلاش نمایید سرور با مشکل مواجه شد",
                            [
                                // {text: 'Ask me later', onPress: () => {}},
                                {
                                    text: i18n.t('constant.ok'), onPress: () => {

                                        //    NavigationService.navigatereset("ApplyScreen", {item: item})
                                    }
                                    //  NavigationService.navigatereset("ApplyScreen",{item: item})

                                    , style: 'cancel'
                                },

                            ],
                            {cancelable: true}
                        )
                        //   NavigationService.navigatereset('LoginStack');
                    }
                    break;

                default:
            }
        }).catch((e) => {

        switch (type) {
            case typeExport.TypeGetExpertRegistrationMahaleMaScreen:
                dispatch(serviceActionError(e))

                break;

            case typeExport.TypeSetExpertRegistrationMahaleMaScreen:
                dispatch(serviceActionErrorSet(e))

                break;

            default:
        }
    })
}


// export const callSetStateCity =  (state_name,state_id,city_name,city_id)  => {

//     return dispatch (serviceActionSuccessSetCityStateData (state_name,state_id,city_name,city_id) )
// }
export const callWebservice = (url, params, type, typeConnection, token, func) => {
    return dispatch => {
        //
        // // if (Platform.OS === 'ios') {
        // //     NetInfo.isConnected.addEventListener('connectionChange', (isConnected) => {
        // //             if (isConnected) {
        // //                 getDataDisatch(dispatch, url, params, type, typeConnection, token);
        // //             }
        // //             else {
        // //                 dispatch(serviceActionError("No Internet Connection"));
        // //             }
        // //         }
        // //     );
        // // }
        // // else {
        //     NetInfo.isConnected.fetch().then(isConnected => {
        //         if (isConnected) {
        //             getDataDisatch(dispatch, url, params, type, typeConnection, token);
        //         }
        //         else {
        //             switch (type) {
        //
        //                 case TypegetExpertRegistrationMahaleMaScreen:
        //                     dispatch(serviceActionError("no connect"));
        //                     break;
        //                 default:
        //             }
        //         }
        //     });
        // //}

        // NetInfo.getConnectionInfo().done(
        //     (isConnected) => {
        //         if (isConnected) {
        //             getDataDisatch(dispatch, url, params, type, typeConnection, token);
        //         }
        //         else {
        //             switch (type) {
        //
        //                 case typeExport.TypeGetExpertRegistrationMahaleMaScreen:
        //                     dispatch(serviceActionError("no connect"));
        //                     break;
        //                 default:
        //             }
        //         }
        //     }
        // )

        if (store.getState().reducerSplashGetAllData.Connection) {
            getDataDisatch(dispatch, url, params, type, typeConnection, token, func);
        }
        else {
            switch (type) {
                case typeExport.TypeGetExpertRegistrationMahaleMaScreen:
                    dispatch(serviceActionError('error_Connection'))

                    break;

                case typeExport.TypeSetExpertRegistrationMahaleMaScreen:
                    dispatch(serviceActionErrorSet('error_Connection'))

                    break;

                default:
            }
        }

    }
}


export const serviceActionPending = () => ({
    type: typeExport.ExpertRegistrationMahaleMaScreen_SERVICE_PENDING,
    NoInternetDialog: false,
    isLoading: true,
    showDialohCity: false

})

export const serviceActionError = (error) => ({
    type: typeExport.ExpertRegistrationMahaleMaScreen_SERVICE_ERROR,
    NoInternetDialog: true,
    error: error,
    isLoading: false,
    showDialohCity: false

})

export const serviceActionSuccess = (data) => ({
    type: typeExport.ExpertRegistrationMahaleMaScreen_SERVICE_SUCCESS,
    NoInternetDialog: false,
    results: data,
    isLoading: false,
})

export const serviceActionPendingSet = () => ({
    type: typeExport.ExpertRegistrationMahaleMaScreen_SERVICE_PENDING_Set,
    NoInternetDialogSet: false,
    isLoadingSet: true,

})

export const serviceActionErrorSet = (error) => ({
    type: typeExport.ExpertRegistrationMahaleMaScreen_SERVICE_ERROR_Set,
    NoInternetDialogSet: true,
    error: error,
    isLoadingSet: false,

})

export const serviceActionSuccessSet = (data) => ({
    type: typeExport.ExpertRegistrationMahaleMaScreen_SERVICE_SUCCESS_Set,
    NoInternetDialogSet: false,
    resultsSet: data,
    isLoadingSet: false,
})
export const serviceActionRefresh = () => ({
    type: typeExport.ExpertRegistrationMahaleMaScreen_SERVICE_REFRESH,
    NoInternetDialog: false,
    results: null,
    isLoading: false,
})


export default connect(mapStateToProps, mapDispatchToProps)(ExpertRegistrationMahaleMaScreen);
